import { render, staticRenderFns } from "./feedback-button.vue?vue&type=template&id=48ca3d66"
import script from "./feedback-button.vue?vue&type=script&lang=ts"
export * from "./feedback-button.vue?vue&type=script&lang=ts"
import style0 from "./feedback-button.vue?vue&type=style&index=0&id=48ca3d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports